import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0146ce21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-questions" }
const _hoisted_2 = { class: "img-group" }
const _hoisted_3 = { class: "img-group__item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "test-answer__style" }, "1")
], -1))
const _hoisted_5 = { class: "img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "img-group__item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "test-answer__style" }, "2")
], -1))
const _hoisted_9 = { class: "img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "img-group__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "test-answer__style" }, "3")
], -1))
const _hoisted_13 = { class: "img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["innerHTML"]

import { ref, inject, toRefs } from "vue"
import { examKey } from "@/main";
import { Page } from "@/store/exam";

interface Props {
  question: Page
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout2',
  props: {
    question: null
  },
  setup(__props: any) {

const props = __props as {
  question: Page
};

const exam = inject(examKey);



const { question } = toRefs(props);

const image1 = ref<string>();
const image2 = ref<string>();
const image3 = ref<string>();

const init = async () => {
  const questions = await exam?.questions();
  if (question.value.questions[0].choices[0].image)
    image1.value = questions?.images[question.value.questions[0].choices[0].image];
  if (question.value.questions[0].choices[1].image)
    image2.value = questions?.images[question.value.questions[0].choices[1].image];
  if (question.value.questions[0].choices[2].image)
    image3.value = questions?.images[question.value.questions[0].choices[2].image];
}
init();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (image1.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: image1.value,
                  alt: ""
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (image2.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: image2.value,
                  alt: ""
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (image3.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: image3.value,
                  alt: ""
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_unref(question).example)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "test-hint",
            innerHTML: _unref(question).questions[0].explanation
          }, null, 8, _hoisted_15))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})